import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import {getMessage} from "../../util";


const useStyles = makeStyles(theme => ({
        paper: {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(2),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'left',
        },
        voted: {
            marginTop: theme.spacing(4),
        },
        paragraph: {
            margin: theme.spacing(2)
        },
        cardGrid: {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8),
        },
        card: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        cardActions: {
            justifyContent: 'center',
        },
        cardContent: {
            flexGrow: 1,
        },
        option: {
            margin: theme.spacing(3),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',

        },
        label: {
            alignItems: 'left',
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: '25ch',
        },

    }
));

const VotedSingle = (props) => {
    const classes = useStyles();

    const option = props.answers.reduce((acc, o) => {
        Object.keys(o.votes).forEach(k => {
            if (o.votes[k].shares > 0) {
                acc[k] = o.name;
            }
        });
        return(acc);

    }, {});

    return(
        <Container maxWidth={"xs"} className={classes.voted}>
            <Typography variant={"h6"} >
                {getMessage(props.meeting.meeting_type, 'voted_message', props.messages)}
            </Typography>

            <Box mt={2}>
                {option && (Object.keys(option).length > 0?Object.keys(option).map(k => (
                    <Typography key={k} variant={"h6"}>
                        <span>
                            {props.user.shares[k].name}
                        </span>: {option[k]}
                        <br/>
                    </Typography>
                )):(
                    <Typography  variant={"h6"} align={"center"}>
                        {getMessage(props.meeting.meeting_type, 'blanks', props.messages)}
                    </Typography>
                ))}
            </Box>



        </Container>
    )
}

export default VotedSingle;